{
  "id": "telefone-ddd",
  "nome": "Anatel DDD Geographic Lookup",
  "fonte": "Anatel Plano de Numeração + IBGE municipios",
  "endpoints": [
    "https://informacoes.anatel.gov.br/paineis/areas-tarifarias/codigos-nacionais",
    "packages/br-validators/src/ibge/data/municipios.json"
  ],
  "capturadoEm": "2026-08-11",
  "atualizadoEm": "2026-08-11T05:04:24.829Z",
  "contagens": {
    "ddds": 67
  },
  "alteracoes": {
    "adicionados": 0,
    "removidos": 0,
    "alterados": 0,
    "comparadoCom": "2026-08-05"
  },
  "verificacao": {
    "agendamento": "diario",
    "workflow": "data-refresh-bot.yml",
    "ultimaExecucao": "2026-08-11T05:04:24.829Z"
  },
  "documentacao": "docs/OFFICIAL-SOURCES.md#anatel-ddd-lookup"
}
